import { render, staticRenderFns } from "./AddObjectsToOrderService.vue?vue&type=template&id=2f155a78&scoped=true"
import script from "./AddObjectsToOrderService.vue?vue&type=script&lang=js"
export * from "./AddObjectsToOrderService.vue?vue&type=script&lang=js"
import style0 from "./AddObjectsToOrderService.vue?vue&type=style&index=0&id=2f155a78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f155a78",
  null
  
)

export default component.exports